import script from "./PaywallBonuses.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallBonuses.vue?vue&type=script&setup=true&lang=js"

import "./PaywallBonuses.vue?vue&type=style&index=0&id=00ff49b4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ff49b4"]])

export default __exports__